import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CargoTypes } from '../../interfaces/cargo-type.interface';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CargoTypeService {

  constructor(
    private http: HttpClient
  ) { }

  getAll(): Observable<CargoTypes[]> {
    return this.http.get<CargoTypes[]>(`${env.api}/cargo-type`);
  }
}
